import { Buttons } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { InquirySideMenu } from "@/components/organisms/InquirySideMenu";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

export const SettingInquiryPage = () => {
  /** 🛣️ Navigation Capability Acquisition */
  const navigate = useNavigate();

  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      pageTitle="서비스 문의"
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="설정"
          onClick={() => navigate("/setting")}
        />
      }
    >
      <InquirySideMenu />
    </MainTemplate>
  );
};
